var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalLeftArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10L0 5L5 0L6.062 1.062L2.125 5L6.062 8.938L5 10Z",
    fill: "#191818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalLeftArrow);
export default __webpack_public_path__ + "static/media/cal_left_arrow.abde3418f88f5a2f45cbe668e0aaea63.svg";
export { ForwardRef as ReactComponent };